import { Injectable } from '@angular/core'

import { Subject } from 'rxjs'

import {
  RealtimeEventType,
  UserDirectoryChangedData,
  UserDirectoryRealtimeScope,
} from '@ti/contracts'
import { RealtimeClient } from '@ti/core/realtime'

import { UserDirectoryKind, UserStoreEvent, UserStoreEventType } from './user-store.types'

@Injectable({ providedIn: 'root' })
export class UserStoreEventBus {
  protected readonly eventSubject = new Subject<UserStoreEvent>()
  public readonly events$ = this.eventSubject.asObservable()
  protected isRealtimeConnected = false

  public connectRealtime(realtimeClient: RealtimeClient): void {
    if (this.isRealtimeConnected) {
      return
    }
    this.isRealtimeConnected = true
    realtimeClient
      .subscribeToEvents(RealtimeEventType.UserDirectoryChanged, (event) => {
        if (event.data) {
          this.publishRealtimeEvent(event.data as UserDirectoryChangedData)
        }
      })
      .catch((error) => {
        this.isRealtimeConnected = false
        console.error('Cannot subscribe to user directory updates', error)
      })
  }

  public publish(event: UserStoreEvent): void {
    this.eventSubject.next(event)
  }

  protected publishRealtimeEvent(data: UserDirectoryChangedData): void {
    for (const directory of this.resolveDirectories(data.scope)) {
      this.publish({ type: UserStoreEventType.Invalidate, directory, fleetId: data.fleetId })
    }
  }

  protected resolveDirectories(scope: UserDirectoryRealtimeScope): UserDirectoryKind[] {
    switch (scope) {
      case UserDirectoryRealtimeScope.Fleet:
        return [UserDirectoryKind.Fleet, UserDirectoryKind.TspFleet]
      case UserDirectoryRealtimeScope.Tsp:
        return [UserDirectoryKind.Tsp, UserDirectoryKind.TiTsp]
      case UserDirectoryRealtimeScope.Ti:
        return [UserDirectoryKind.TiAdmin]
    }
  }
}
